import {getDominantBlockType, withX, withType, getBlocks} from '../calculateRules.js';
import {
    ACCENT,
    FLAM,
    REGULAR,
    STACCATO,
    DOUBLE,
    REST,
    LEGATO,
    PIANO,
    PIANISSIMO
} from 'effects/midi/scripting/trules.js';
import {getFullBlocks} from './getFullBlocks.js';
import {byX} from './utils.js';

import {doc} from './docs.js';

const MAX_BLOCK = 15;
doc(
    "add",
    {
        "blockNumber": "block to add to",
        "position": "position to add it to",
        "type": "type to add",
    },
    "Adds a cell to block at a certain position"
);
export const add = (grid, blockNumber, position, type) => {
    let {cells, size} = grid;

    // write now getBlocks returns only the "on" positions
    // what we want is every possible position within a block
    let blocks = getFullBlocks(cells, size);

    let block = blocks[blockNumber % blocks.length];
    if (!block || !type) {
        return;
    }
    
    let blockByX = byX(block);
    let keys = Object.keys(blockByX).map(x => parseFloat(x));
    if (position === undefined || position === -1) {
        let min = 1000;
        for (let x in blockByX) {
            if (blockByX[x].length < min) {
                min = blockByX[x].length;
                position = keys.indexOf(parseInt(x));
            }
        }
    }
    let x = keys[position%keys.length];

    let toInsert = {
        type,
        value: ''
    };
    if (x === undefined) {
        let dominantType = getDominantBlockType(block, cells);
        let dominantPosition = withType(block, cells, dominantType)[0];
        if (dominantPosition) {
            let y = dominantPosition.y;
            let x = Math.max(... block.map(p => p.x));
            if (dominantType === '-' && x === dominantPosition.x) {
                x++;
            }
            x++;
            grid.set(x,y,toInsert);
        }
    } else {
        // we need to first see if we are adding a piece
        // that conflicts with other pieces (in which case we replace
        // that one with this new one we're adding)
        x = parseInt(x);
        let pieces = blockByX[x];
        let conflicts = getConflicts(grid.cells, pieces, toInsert);
        if (conflicts) {
            grid.set(conflicts.x,conflicts.y,toInsert);
        } else {
            let maxY = Math.max(... pieces.map(p => p.y));
            let y = maxY+1;
            grid.set(x,y,toInsert);
        }
    }
};

const DURATIONS = [STACCATO, LEGATO].map(x => x.type);
const VELOCITIES = [PIANISSIMO, PIANO, REGULAR, ACCENT, REST].map(x => x.type);
export const getConflicts = (cells, pieces, piece) => {
    for (let i=0; i < pieces.length; i++) {
        let {x,y} =  pieces[i];
        let conf = isConflicting(cells[y][x].type, piece.type);
        if (conf) {
            return {x,y};
        }
    }
    return undefined;
};

export const isConflicting = (a,b) => {
    if (a=== b) {
        return true;
    }
    if (DURATIONS.includes(a) && DURATIONS.includes(b)) {
        return true;
    }
    if (VELOCITIES.includes(a) && VELOCITIES.includes(b)) {
        return true;
    }
    return false;
};

